import { selector, selectorFamily } from "recoil";
import { getDefaultAllTicketFields } from "../../lib/ticket";
import ticketFieldListState from "../ticketFieldListState";

export const customFieldsState = selector({
  key: 'customFieldListState',
  get: ({ get }) => {
    const fields = get(ticketFieldListState);
    const defaults = getDefaultAllTicketFields()
    const defaultCodes = defaults.map((_default) => _default.code)
    return fields?.filter((field) => !defaultCodes.includes(field.code))
  }
});

export const ticketFieldState = selectorFamily({
  key: 'ticketField',
  get: (fieldId) => ({ get }) => {
    const fields = get(ticketFieldListState)
    return fields?.find((_field) => {
      return _field.id == fieldId
    })
  }
});